import styled from "styled-components";
import { ThemeProps } from "../../styles/theme";

export const TableWrapper = styled.div`
    width: 100%;
    overflow-x: auto;
`;

export const TableGrid = styled.div<ThemeProps & { $cols: number }>`
    display: grid;
    grid-template-columns: repeat(${p => p.$cols}, auto);
    border: 1px solid ${p => p.theme.primaryBorder};
    border-radius: 8px;
    overflow: hidden;
    box-sizing: border-box;
`;

interface CellProps extends ThemeProps {
    $isFirstRow: boolean;
    $isLastCol: boolean;
}

export const DataCell = styled.div<CellProps & { $highlight: boolean }>`
    padding: 6px 10px;
    font-size: 14px;
    line-height: 1.35;
    color: ${p => p.theme.primaryForeground};
    overflow-wrap: break-word;
    word-break: break-word;
    border-top: ${p => p.$isFirstRow ? 'none' : `1px solid ${p.theme.primaryBorder}`};
    border-right: ${p => p.$isLastCol ? 'none' : `1px solid ${p.theme.primaryBorder}`};
    background: ${p => p.$highlight ? `${p.theme.accentColor}15` : 'transparent'};
`;

export const HeaderCell = styled.div<CellProps>`
    padding: 6px 10px;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.35;
    color: ${p => p.theme.primaryForeground};
    background: ${p => `${p.theme.accentColor}22`};
    border-bottom: 2px solid ${p => p.theme.accentColor};
    border-right: ${p => p.$isLastCol ? 'none' : `1px solid ${p.theme.primaryBorder}`};
`;

export const FullWidthCell = styled.div<ThemeProps & { $isFirstRow: boolean }>`
    grid-column: 1 / -1;
    padding: 6px 10px;
    font-size: 14px;
    line-height: 1.35;
    color: ${p => p.theme.secondaryText};
    border-top: ${p => p.$isFirstRow ? 'none' : `1px solid ${p.theme.primaryBorder}`};
`;
